import { render, staticRenderFns } from "./talentInfoDialog.vue?vue&type=template&id=557b99d8&scoped=true"
import script from "./talentInfoDialog.vue?vue&type=script&lang=js"
export * from "./talentInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./talentInfoDialog.vue?vue&type=style&index=0&id=557b99d8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b99d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557b99d8')) {
      api.createRecord('557b99d8', component.options)
    } else {
      api.reload('557b99d8', component.options)
    }
    module.hot.accept("./talentInfoDialog.vue?vue&type=template&id=557b99d8&scoped=true", function () {
      api.rerender('557b99d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/talentInfoDialog.vue"
export default component.exports